import React from 'react';
import styles from './TextInput.module.css';

const TextInput = ({ icon, placeholder, type = 'text', value, onChange, name }) => {
  return (
    <div className={styles.inputWrapper}>
      <span className={styles.inputIcon}>{icon}</span>
      <input
        className={styles.inputField}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        name={name}
      />
    </div>
  );
};

export default TextInput;
